export const pathConstants = {
  empty: "",
  defaultRoute: "/",
  wildCard: "*",
  login: "/login",
  dashboard: "/dashboard",
  orders: "/orders",
  orderDetail: "/orders/:id",
  employees: "/employees",
  customers: "/customers",
  profile: "/profile",
  configuration: "/configuration",
  configurationTags: "/configuration/tags",
  configurationSettings: "/configuration/system-settings",
  configurationProvider: "/configuration/provider",
  configurationLockers: "/configuration/lockers",
  configurationPickToLight: "/configuration/pick-to-light",
  configurationManifest: "/configuration/manifest",
  configurationNotifications: "/configuration/notifications",
  configurationWorkingHours: "/configuration/working-hours",
  configurationBagTypes: "/configuration/bag-types",
  recurringOrders: "/recurring-orders",
  addresses: "/addresses",
  links: "/links",
  couriers: "/couriers",
  reports: "/reports",
  reportsAccounting: "/reports/accounting",
  reportsTravel: "/reports/travel",
  reportsConformity: "/reports/conformity",
  reportsImmobility: "/reports/immobility",
  // Legacy screens routed ahead of their feature — render WorkInProgressPage (DEV-394)
  dashboardLockers: "/dashboard/lockers",
  lockers: "/lockers",
  pickToLight: "/pick-to-light",
  routePlanning: "/route-planning",
  billing: "/billing",
  support: "/support",
}
